module.exports = __webpack_public_path__ + "static/media/ciudadano.bfe47daa.png";